import invoiceModule from '../module'

invoiceModule.directive('toFixed', () => ({
  restrict: 'A',
  scope: true,
  require: 'ngModel',
  link(scope, ele, attrs, ngModelCtroller) {
    ele.on('blur', () => {
      //支持千位符，使用to-fixed转换，参数大于等于15时只做转换不进行小数位保留
      const value = parseFloat(Number(ele.val().replace(/\,/g, '')))
      if ((value || value === 0) && attrs.toFixed < 15) {
        ngModelCtroller.$setViewValue(value.toFixed(attrs.toFixed))
      } else if (attrs.toFixed >= 15) {
        ngModelCtroller.$setViewValue(value)
      } else {
        ngModelCtroller.$setViewValue('')
      }
      ngModelCtroller.$render()
    })
    ngModelCtroller.$render = function render() {
      ele.val(ngModelCtroller.$viewValue)
    }
    // ngModelCtroller.render()
  },
}))
invoiceModule.directive('toPercent', () => ({
  restrict: 'A',
  scope: true,
  require: 'ngModel',
  link(scope, ele, attrs, ngModelCtroller) {
    ele.on('blur', () => {
      //使用to-percent转换
      const value = parseFloat(Number(ele.val().replace(/\%/g, '')))
      console.log(value)
      if ((value || value === 0) && attrs.toPercent < 15) {
        // ngModelCtroller.$setViewValue(
        //   Number(value / 100).toFixed(attrs.toPercent) + '%'
        // )
        ngModelCtroller.$setViewValue(Number(value) + '%')
      } else {
        ngModelCtroller.$setViewValue('')
      }
      ngModelCtroller.$render()
    })
    ngModelCtroller.$render = function render() {
      ele.val(ngModelCtroller.$viewValue)
    }
    // ngModelCtroller.render()
  },
}))



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/toFixed.js